import * as React from 'react';
import { SVGProps } from 'react';

const IconSunSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#SvgIconSun_size_xs__clip0)">
      <path d="M2.464 1.757a.5.5 0 1 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zM.5 5.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm6-5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zM1.757 9.536a.5.5 0 0 0 .707.707l.708-.707a.5.5 0 1 0-.708-.708l-.707.708zm7.071-7.071a.5.5 0 0 0 .707.707l.708-.707a.5.5 0 1 0-.708-.708l-.707.708zM6.5 10.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm4-5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm-.964 3.328a.5.5 0 1 0-.708.708l.708.707a.5.5 0 1 0 .707-.707l-.707-.708z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
      />
    </g>
  </svg>
);
export default IconSunSizeXs;
